// Copyright (c) StrangeBee 2024

import client from '@Client';
import useListQuery from '@Hooks/useListQuery';
import { columnsRenderer } from '@Hooks/useConfigList/helper/computeHeader';
import { useStreamObserver } from '@Hooks/useStream';
import ResponderReports from '@Organisms/Report/ResponderReports/ResponderReports';
import { STREAM_EVENTS } from '@Services/StreamSrv';
import React, { ReactElement } from 'react';
import { AuditOutput } from 'thehive-sdk';

interface TaskLogItemReportsProps {
    taskLogId: string;
    className?: string;
}

const actionIsTaskLog = (audit: AuditOutput): boolean => audit.base?.details?.objectType === 'Log';

const TaskLogItemReports = ({ taskLogId }: TaskLogItemReportsProps): ReactElement => {
    const { data: taskLogReports, refetch: refetchReports } = useListQuery({
        queryParams: {
            selector: {
                name: 'get-task-reports',
                head: [
                    {
                        name: 'getLog',
                        idOrName: taskLogId,
                    },
                    {
                        name: 'actions',
                    },
                ],
            },
            sort: ['-startDate'],
        },
        controller: client.TaskLogController,
    });

    useStreamObserver({ objectType: STREAM_EVENTS.ACTION }, (audits) => {
        if (audits.some(actionIsTaskLog)) {
            refetchReports();
        }
    });

    return <ResponderReports reports={taskLogReports} columnsRenderer={columnsRenderer} />;
};

export default TaskLogItemReports;
